module.exports = __webpack_public_path__ + "static/media/logo.ec5859cf.png";